import type * as React from "react";

type TaskGlyphProps = { size?: number | string } & React.SVGProps<SVGSVGElement>;

const TASK_GLYPH_STROKE_WIDTH = 2 * (16 / 24);

export const TaskGlyphIcon = ({ size = 24, ...props }: TaskGlyphProps) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="4 4 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M9.75 11.25L12 13.5L18 7.5M18 12V16.5C18 16.8978 17.842 17.2794 17.5607 17.5607C17.2794 17.842 16.8978 18 16.5 18H7.5C7.10218 18 6.72064 17.842 6.43934 17.5607C6.15804 17.2794 6 16.8978 6 16.5V7.5C6 7.10218 6.15804 6.72064 6.43934 6.43934C6.72064 6.15804 7.10218 6 7.5 6H14.25"
				stroke="currentColor"
				strokeWidth={TASK_GLYPH_STROKE_WIDTH}
				fill="none"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
